
import store from "@/store";
import { computed, defineComponent, onMounted, ref } from "vue";
import * as Types from "@/store/action-types";

export default defineComponent({
  setup() {
      const updateVisibleModal = ref(true);
    /**
     * 获取上线提示信息
     */
    const getUpdateContent = async () => {
      store.dispatch(`app/${Types.SET_UPDATE_CONTENT}`);
    };
    const updateContent = computed(() => store.state.app.updateContent);

     const updateStatus = computed({
      get: () => store.state.app.updateContent.status,
      set: (val) => {
        store.state.app.updateContent.status = val;
      },
    });
    /**
     * 关闭上线信息提示框
     */
    function closeModal() {
    //   updateStatus = 0;
    }

    onMounted(async () => {
      //获取上线提示信息
      await getUpdateContent();
      updateVisibleModal.value = updateContent.value.status == 1 ? true:false;
    });
    return {
        updateContent,
        updateStatus,
        updateVisibleModal,
      closeModal,
    };
  },
});
